// STEP 1 - Include Dependencies
// Include react
import React from "react";
import ReactDOM from "react-dom";

// Include the react-fusioncharts component
import ReactFC from "react-fusioncharts";

// Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Include the chart type
import Column2D from "fusioncharts/fusioncharts.charts";

// Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

// STEP 2 - Chart Data
function CurrentValueCat2(props) {
  //console.log("4th drill", props);
  let colors = ["#89C4F4", "#333333", "#808080", "#CCCCCC", "#BBBBBB"];
  let rows = [];
  Object.keys(props.doughnutCurrent2).map((key, index) => {
    rows.push({
      key: key,
      label: props.doughnutCurrent2[key].schemeName,
      value: props.doughnutCurrent2[key].investedValue,
      //schemDesc: props.doughnutCurrent2[key].schemeDesc,
      color: colors[index],
      displayValue: props.doughnutCurrent2[key].schemeDesc,
    });
  });
  //console.log("ROWS Current CAT2--", rows);
  const chartData = rows;

  // STEP 3 - Creating the JSON object to store the chart configurations
  const chartConfigs = {
    type: "doughnut2d", // The chart type
    width: "270", // Width of the chart
    height: "350", // Height of the chart
    dataFormat: "json", // Data type
    dataSource: {
      // Chart Configuration
      chart: {
        caption: "Current Value",
        doughnutRadius: "65%",
        //subcaption: "For all users in 2017",
        showpercentvalues: "1",
        defaultcenterlabel: "₹" + props.totalCurrent2,
        aligncaptionwithcanvas: "0",
        enableSlicing: "0",
        enableRotation: "0",
        captionpadding: "0",
        decimals: "1",
        showlabels: "0",
        showValues: "0",
        plottooltext: "<b>$percentValue</b> {BR} <b>$displayValue</b>",
        // centerlabel: "# Invested Value: $value",
        theme: "fusion",
        // legendNumRows: "2",
        legendNumColumns: "2",
        legendItemFontSize: "12",
        chartLeftMargin: "0",
        chartTopMargin: "0",
        chartRightMargin: "0",
        chartBottomMargin: "0",
      },
      // Chart Data
      data: chartData,
    },
  };

  return <ReactFC {...chartConfigs} />;
}

export default CurrentValueCat2;
